import { Component, ChangeDetectionStrategy } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';

@Component({
    selector: 'app-module-layout',
    imports: [HeaderComponent, RouterOutlet, FooterComponent],
    templateUrl: './module-layout.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './module-layout.component.css',
})
export class ModuleLayoutComponent {}
